module.exports = __webpack_public_path__ + "static/media/Washington_Capitals.d6c9ef8c.svg";